import { z } from 'zod';

// ═══════════════════════════════════════════════════════════════
// ONBOARDING — Declaración PEP (Persona Políticamente Expuesta).
// Endpoint `PATCH /api/v1/onboarding/pep-declaration`, body
// [is_pep, pep_position, pep_relationship].
//
// En Persona Moral declara el REPRESENTANTE LEGAL (GAP 6 #412): si `isPep` es
// true, el BE marca la cuenta como `enhanced_due_diligence` y dispara revisión
// manual antes de activar (ver docs/plans/persona-moral/00-backend-contracts.md).
//
// Cuando `isPep` es false, position/relationship no aplican y se envían vacíos.
// Cuando es true, ambos son requeridos.
// ═══════════════════════════════════════════════════════════════

export const pepDeclarationSchema = z
  .object({
    /** ¿Es Persona Políticamente Expuesta? (→ `is_pep`). */
    isPep: z.boolean(),
    /** Cargo público que ocupa u ocupó (→ `pep_position`). */
    pepPosition: z.string().trim().default(''),
    /**
     * Relación con la PEP cuando se declara por vínculo (familiar/asociado)
     * (→ `pep_relationship`).
     */
    pepRelationship: z.string().trim().default(''),
  })
  .superRefine((data, ctx) => {
    if (data.isPep && data.pepPosition.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['pepPosition'],
        message: 'Indica el cargo público',
      });
    }
    if (data.isPep && data.pepRelationship.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['pepRelationship'],
        message: 'Indica la relación con la PEP',
      });
    }
  });

export type PepDeclarationFormData = z.infer<typeof pepDeclarationSchema>;
